import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { defineProperties } from "../utils/properties.js";
import { assertArgument } from "../utils/index.js";
var EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
/**
 *  A **NetworkPlugin** provides additional functionality on a [[Network]].
 */
export var NetworkPlugin = /*#__PURE__*/function () {
  /**
   *  The name of the plugin.
   *
   *  It is recommended to use reverse-domain-notation, which permits
   *  unique names with a known authority as well as hierarchal entries.
   */

  /**
   *  Creates a new **NetworkPlugin**.
   */
  function NetworkPlugin(name) {
    _classCallCheck(this, NetworkPlugin);
    _defineProperty(this, "name", void 0);
    defineProperties(this, {
      name: name
    });
  }
  /**
   *  Creates a copy of this plugin.
   */
  _createClass(NetworkPlugin, [{
    key: "clone",
    value: function clone() {
      return new NetworkPlugin(this.name);
    }
  }]);
  return NetworkPlugin;
}();
/**
 *  A **GasCostPlugin** allows a network to provide alternative values when
 *  computing the intrinsic gas required for a transaction.
 */
export var GasCostPlugin = /*#__PURE__*/function (_NetworkPlugin) {
  _inherits(GasCostPlugin, _NetworkPlugin);
  var _super = _createSuper(GasCostPlugin);
  /**
   *  The block number to treat these values as valid from.
   *
   *  This allows a hardfork to have updated values included as well as
   *  mulutiple hardforks to be supported.
   */

  /**
   *  The transactions base fee.
   */

  /**
   *  The fee for creating a new account.
   */

  /**
   *  The fee per zero-byte in the data.
   */

  /**
   *  The fee per non-zero-byte in the data.
   */

  /**
   *  The fee per storage key in the [[link-eip-2930]] access list.
   */

  /**
   *  The fee per address in the [[link-eip-2930]] access list.
   */

  /**
   *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
   *  latest block or another GasCostPlugin supercedes that block number,
   *  with the associated %%costs%%.
   */
  function GasCostPlugin(effectiveBlock, costs) {
    var _this;
    _classCallCheck(this, GasCostPlugin);
    if (effectiveBlock == null) {
      effectiveBlock = 0;
    }
    _this = _super.call(this, "org.ethers.network.plugins.GasCost#".concat(effectiveBlock || 0));
    _defineProperty(_assertThisInitialized(_this), "effectiveBlock", void 0);
    _defineProperty(_assertThisInitialized(_this), "txBase", void 0);
    _defineProperty(_assertThisInitialized(_this), "txCreate", void 0);
    _defineProperty(_assertThisInitialized(_this), "txDataZero", void 0);
    _defineProperty(_assertThisInitialized(_this), "txDataNonzero", void 0);
    _defineProperty(_assertThisInitialized(_this), "txAccessListStorageKey", void 0);
    _defineProperty(_assertThisInitialized(_this), "txAccessListAddress", void 0);
    var props = {
      effectiveBlock: effectiveBlock
    };
    function set(name, nullish) {
      var value = (costs || {})[name];
      if (value == null) {
        value = nullish;
      }
      assertArgument(typeof value === "number", "invalud value for ".concat(name), "costs", costs);
      props[name] = value;
    }
    set("txBase", 21000);
    set("txCreate", 32000);
    set("txDataZero", 4);
    set("txDataNonzero", 16);
    set("txAccessListStorageKey", 1900);
    set("txAccessListAddress", 2400);
    defineProperties(_assertThisInitialized(_this), props);
    return _this;
  }
  _createClass(GasCostPlugin, [{
    key: "clone",
    value: function clone() {
      return new GasCostPlugin(this.effectiveBlock, this);
    }
  }]);
  return GasCostPlugin;
}(NetworkPlugin);
/**
 *  An **EnsPlugin** allows a [[Network]] to specify the ENS Registry
 *  Contract address and the target network to use when using that
 *  contract.
 *
 *  Various testnets have their own instance of the contract to use, but
 *  in general, the mainnet instance supports multi-chain addresses and
 *  should be used.
 */
export var EnsPlugin = /*#__PURE__*/function (_NetworkPlugin2) {
  _inherits(EnsPlugin, _NetworkPlugin2);
  var _super2 = _createSuper(EnsPlugin);
  /**
   *  The ENS Registrty Contract address.
   */

  /**
   *  The chain ID that the ENS contract lives on.
   */

  /**
   *  Creates a new **EnsPlugin** connected to %%address%% on the
   *  %%targetNetwork%%. The default ENS address and mainnet is used
   *  if unspecified.
   */
  function EnsPlugin(address, targetNetwork) {
    var _this2;
    _classCallCheck(this, EnsPlugin);
    _this2 = _super2.call(this, "org.ethers.plugins.network.Ens");
    _defineProperty(_assertThisInitialized(_this2), "address", void 0);
    _defineProperty(_assertThisInitialized(_this2), "targetNetwork", void 0);
    defineProperties(_assertThisInitialized(_this2), {
      address: address || EnsAddress,
      targetNetwork: targetNetwork == null ? 1 : targetNetwork
    });
    return _this2;
  }
  _createClass(EnsPlugin, [{
    key: "clone",
    value: function clone() {
      return new EnsPlugin(this.address, this.targetNetwork);
    }
  }]);
  return EnsPlugin;
}(NetworkPlugin);
/**
 *  A **FeeDataNetworkPlugin** allows a network to provide and alternate
 *  means to specify its fee data.
 *
 *  For example, a network which does not support [[link-eip-1559]] may
 *  choose to use a Gas Station site to approximate the gas price.
 */
var _feeDataFunc = /*#__PURE__*/new WeakMap();
export var FeeDataNetworkPlugin = /*#__PURE__*/function (_NetworkPlugin3) {
  _inherits(FeeDataNetworkPlugin, _NetworkPlugin3);
  var _super3 = _createSuper(FeeDataNetworkPlugin);
  /**
   *  Creates a new **FeeDataNetworkPlugin**.
   */
  function FeeDataNetworkPlugin(feeDataFunc) {
    var _this3;
    _classCallCheck(this, FeeDataNetworkPlugin);
    _this3 = _super3.call(this, "org.ethers.plugins.network.FeeData");
    _classPrivateFieldInitSpec(_assertThisInitialized(_this3), _feeDataFunc, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(_assertThisInitialized(_this3), _feeDataFunc, feeDataFunc);
    return _this3;
  }
  /**
   *  Resolves to the fee data.
   */
  _createClass(FeeDataNetworkPlugin, [{
    key: "feeDataFunc",
    get:
    /**
     *  The fee data function provided to the constructor.
     */
    function get() {
      return _classPrivateFieldGet(this, _feeDataFunc);
    }
  }, {
    key: "getFeeData",
    value: function () {
      var _getFeeData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _classPrivateFieldGet(this, _feeDataFunc).call(this, provider);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getFeeData(_x) {
        return _getFeeData.apply(this, arguments);
      }
      return getFeeData;
    }()
  }, {
    key: "clone",
    value: function clone() {
      return new FeeDataNetworkPlugin(_classPrivateFieldGet(this, _feeDataFunc));
    }
  }]);
  return FeeDataNetworkPlugin;
}(NetworkPlugin);
/*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/